import { render, staticRenderFns } from "./SecurityActionErrorDialog.vue?vue&type=template&id=5d961cc1&scoped=true"
import script from "./SecurityActionErrorDialog.vue?vue&type=script&lang=js"
export * from "./SecurityActionErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./SecurityActionErrorDialog.vue?vue&type=style&index=0&id=5d961cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d961cc1",
  null
  
)

export default component.exports